import { getDpsEnvironmentUrl } from '../config';
import errors from '../settings/errors';
export const createImageCall = (url) => {
    var image = new Image();
    image.src = url;
};
export const fetchAvailable = () => {
    return window && 'fetch' in window; // If 'fetch' does not exist within the window, this browser does not support fetch.
};
export const sendToDps = (paramString) => {
    const dpsEndpoint = getDpsEnvironmentUrl();
    // do not make a fetch call if the service is disabled for development purposes
    if (typeof dpsEndpoint === 'undefined' || dpsEndpoint.length === 0) {
        console.warn(errors.serviceDisabled);
        return;
    }
    if (fetchAvailable()) {
        fetch(`${dpsEndpoint}?${paramString}`, {
            method: 'GET',
            credentials: 'include',
            redirect: 'follow',
            mode: 'no-cors',
            cache: 'no-store',
            keepalive: true,
        });
    }
    else {
        createImageCall(`${dpsEndpoint}?${paramString}`);
    }
};
//# sourceMappingURL=dps.service.js.map